<div class="asset-monitor">
  <header class="asset-header">
    <div class="asset-heading">
      <div class="asset-avatar" aria-hidden="true">
        <img [src]="assetTypeIconUrl" alt="" (error)="handleAssetTypeIconError()">
      </div>
      <div>
        <div class="title-row">
          <h1>{{ assetName }}</h1>
          <span class="connectivity" [class.offline]="!hasCurrentData">
            <span class="connectivity-dot"></span>
            {{ hasCurrentData ? 'Con datos' : 'Sin datos' }}
          </span>
        </div>
        <p>{{ assetTypeName }} <span>•</span> ID: {{ assetInternalCode }}</p>
        <p class="location-line">
          <i class="feather icon-map-pin" aria-hidden="true"></i>
          {{ installationName }} <span>•</span> {{ assetAddress }}
        </p>
      </div>
    </div>
    <button type="button" class="close-monitor" aria-label="Cerrar" (click)="requestClose()">×</button>
  </header>

  <div class="monitor-layout">
    <aside class="asset-panel panel">
      <div class="panel-title">Activo instalado</div>
      <div class="asset-visual">
        <ng-container *ngIf="photoSlides.length; else assetIcon">
          <img *ngFor="let slide of photoSlides; let i = index" class="installation-photo" [class.active]="i === photoIndex"
               [src]="slide.url" [alt]="'Foto de instalación ' + slide.photo">
          <ng-container *ngIf="photoSlides.length > 1">
            <button type="button" class="photo-nav prev" aria-label="Foto anterior" (click)="showPreviousPhoto()">‹</button>
            <button type="button" class="photo-nav next" aria-label="Foto siguiente" (click)="showNextPhoto()">›</button>
            <div class="photo-dots">
              <button type="button" *ngFor="let slide of photoSlides; let i = index" [class.active]="i === photoIndex"
                      [attr.aria-label]="'Ver foto ' + slide.photo" (click)="photoIndex = i"></button>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #assetIcon>
          <div class="visual-glow"></div>
          <img [src]="assetImageUrl" [alt]="assetDescription" [class.location-image]="hasLocationImage"
               (error)="handleAssetImageError()">
        </ng-template>
      </div>

      <dl class="asset-details">
        <div>
          <dt>Tipo de activo</dt>
          <dd>{{ assetTypeName }}</dd>
        </div>
        <div>
          <dt>Modelo</dt>
          <dd>{{ assetModel }}</dd>
        </div>
        <div>
          <dt>Descripción</dt>
          <dd>{{ assetDescription }}</dd>
        </div>
        <div>
          <dt>Instalación</dt>
          <dd>{{ installationName }}</dd>
        </div>
        <div>
          <dt>Ubicación</dt>
          <dd>{{ assetAddress }}</dd>
        </div>
        <div>
          <dt>Última actualización</dt>
          <dd>{{ lastUpdate ? (lastUpdate | date:'dd/MM/yyyy HH:mm') : 'Sin datos' }}</dd>
        </div>
      </dl>

      <div class="asset-health" [ngClass]="overallHealth.cssClass">
        <div class="health-icon">{{ overallHealth.icon }}</div>
        <div>
          <span>Estado general del activo</span>
          <strong>{{ overallHealth.name }}</strong>
          <small>{{ overallHealth.detail }}</small>
        </div>
      </div>
    </aside>

    <main class="monitor-content">
      <section class="health-panel panel">
        <div class="section-heading">
          <div><h2>Indicadores de salud</h2></div>
          <div class="legend">
            <span><i class="ok"></i> Óptimo</span>
            <span><i class="warning"></i> Advertencia</span>
            <span><i class="bad"></i> Alerta</span>
            <span><i class="missing"></i> Sin evaluación / datos</span>
          </div>
        </div>

        <div class="health-grid" [class.has-position]="isEcoCore">
          <article class="health-card" *ngFor="let indicator of healthIndicators"
                   [class.no-data]="!indicator.hasValue" [ngClass]="'health-' + indicator.status">
            <div class="metric-icon">{{ indicator.icon }}</div>
            <span>{{ indicator.title }}</span>
            <strong>{{ indicator.value }}</strong>
            <small>{{ indicator.statusLabel }}</small>
            <small class="metric-range">{{ indicator.range }}</small>
          </article>
        </div>
      </section>

      <section class="history-panel panel">
        <nav class="monitor-tabs" role="tablist" aria-label="Datos monitoreados del activo">
          <button type="button" role="tab" [class.active]="activeTab === 'history'"
                  [attr.aria-selected]="activeTab === 'history'" (click)="selectTab('history')">
            <span class="tab-symbol">⌁</span> Historial de datos
          </button>
          <button type="button" role="tab" [class.active]="activeTab === 'alarms'"
                  [attr.aria-selected]="activeTab === 'alarms'" (click)="selectTab('alarms')">
            <i class="feather icon-bell"></i> Alarmas
            <span class="tab-count">{{ alarmList?.length || 0 }}</span>
          </button>
          <button type="button" role="tab" [class.active]="activeTab === 'location'"
                  [attr.aria-selected]="activeTab === 'location'" (click)="selectTab('location')">
            <i class="feather icon-map-pin"></i> Mapa de ubicación
          </button>
          <button type="button" role="tab" [class.active]="activeTab === 'configuration'"
                  [attr.aria-selected]="activeTab === 'configuration'" (click)="selectTab('configuration')">
            <i class="feather icon-shield"></i> Configuración
          </button>
          <button type="button" role="tab" [class.active]="activeTab === 'information'"
                  [attr.aria-selected]="activeTab === 'information'" (click)="selectTab('information')">
            <i class="feather icon-info"></i> Información
          </button>
        </nav>

        <div class="loading-overlay" *ngIf="loading" role="status" aria-live="polite">
          <div class="loading-card">
            <span class="loader" aria-hidden="true"></span>
            <div><strong>Cargando datos del activo</strong><small>Consultando valores actuales e históricos…</small></div>
            <span class="loading-progress" aria-hidden="true"></span>
          </div>
        </div>

        <div class="error-banner" *ngIf="!loading && loadErrors.length">
          <strong>Información parcial</strong>
          <span>{{ loadErrors.join(' ') }}</span>
        </div>

        <ng-container>
          <section class="tab-content alarm-workspace" [hidden]="activeTab !== 'alarms'"
                   [attr.aria-hidden]="activeTab !== 'alarms'">
            <div class="chart-heading">
              <div><h2>Alarmas del período</h2><p>Distribución por hora y tipo de sensor.</p></div>
              <span class="sample-badge">{{ alarmList?.length || 0 }} alarmas · {{ alarmRangeLabel }}</span>
            </div>
            <div class="alarm-toolbar">
              <label>
                <span>Período</span>
                <select [(ngModel)]="alarmRange" (change)="onAlarmRangeChange()">
                  <option value="24h">Últimas 24 horas</option>
                  <option value="7d">Últimos 7 días</option>
                  <option value="30d">Últimos 30 días</option>
                  <option value="custom">Personalizado</option>
                </select>
              </label>
              <div class="custom-range alarm-custom-range" *ngIf="alarmRange === 'custom'">
                <label><span>Desde</span><input type="datetime-local" [(ngModel)]="alarmCustomStart"></label>
                <label><span>Hasta</span><input type="datetime-local" [(ngModel)]="alarmCustomEnd"></label>
                <button type="button" (click)="applyAlarmCustomRange()">Aplicar</button>
              </div>
            </div>
            <div class="alarm-chart-container" *ngIf="!alarmLoading && alarmChartReady; else alarmChartState">
              <canvas #alarmChart baseChart [datasets]="alarmChartData" [labels]="[]" [options]="alarmChartOptions"
                      [colors]="alarmChartColors" [legend]="alarmChartLegend" [chartType]="alarmChartType"></canvas>
            </div>
            <ng-template #alarmChartState>
              <div class="empty-state alarm-chart-state" *ngIf="alarmLoading">
                <div class="loader" aria-hidden="true"></div><h3>Cargando alarmas</h3>
                <p>Consultando el período seleccionado.</p>
              </div>
              <div class="empty-state alarm-chart-state" *ngIf="!alarmLoading">
                <div class="empty-icon">✓</div><h3>{{ alarmLoadError ? 'No fue posible cargar las alarmas' : 'Sin alarmas' }}</h3>
                <p>{{ alarmLoadError || 'No existen alarmas para mostrar durante el período seleccionado.' }}</p>
              </div>
            </ng-template>
          </section>

          <section class="tab-content history-workspace" *ngIf="activeTab === 'history'">
            <div class="history-data-card">
              <div class="content-card-heading"><h2>Historial de datos</h2></div>
              <div class="history-toolbar">
                <label>
                  <span>Variable</span>
                  <select [ngModel]="selectedHistorySensorId" (ngModelChange)="selectHistoryVariable($event)">
                    <option *ngFor="let metric of historyMetrics" [ngValue]="metric.sensorId">
                      {{ metric.label }} ({{ metric.unit }})
                    </option>
                  </select>
                </label>
                <label>
                  <span>Período</span>
                  <select [(ngModel)]="historyRange" (change)="onHistoryRangeChange()">
                    <option value="24h">Últimas 24 horas</option>
                    <option value="7d">Últimos 7 días</option>
                    <option value="30d">Últimos 30 días</option>
                    <option value="custom">Personalizado</option>
                  </select>
                </label>
                <button type="button" class="export-button" [disabled]="activeStats.sampleCount === 0"
                        (click)="exportHistoryCsv()">
                  <i class="feather icon-download" aria-hidden="true"></i> Descargar datos
                </button>
              </div>
              <div class="custom-range history-custom-range" *ngIf="historyRange === 'custom'">
                <label><span>Desde</span><input type="datetime-local" [(ngModel)]="customStart"></label>
                <label><span>Hasta</span><input type="datetime-local" [(ngModel)]="customEnd"></label>
                <button type="button" (click)="applyCustomRange()">Aplicar</button>
              </div>
              <div class="chart-heading">
                <div><h2>{{ activeMetric.title }}</h2><p>{{ activeMetric.description }}</p></div>
                <div class="chart-badges">
                  <span class="sample-badge reference-badge" *ngIf="chartReady && activeReferenceValue !== null">
                    <i [style.border-top-color]="activeReferenceColor"></i>{{ activeReferenceLabel }}: {{ formatValue(activeReferenceValue, activeMetric.unit) }}</span>
                  <span class="sample-badge">{{ activeStats.sampleCount }} datos · {{ historyRangeLabel }}</span>
                </div>
              </div>
              <div class="chart-container" *ngIf="chartReady; else noScalarData">
                <canvas #historyChart baseChart [datasets]="chartData" [labels]="chartLabels" [options]="chartOptions"
                        [colors]="chartColors" [legend]="chartLegend" [chartType]="chartType" [plugins]="chartPlugins"></canvas>
              </div>
              <ng-template #noScalarData>
                <div class="empty-state history-empty"><div class="empty-icon">{{ activeMetric.icon }}</div><h3>{{ activeMetric.emptyTitle }}</h3>
                  <p>No existen lecturas válidas para {{ historyRangeLabel }}.</p></div>
              </ng-template>
              <div class="battery-insights" *ngIf="activeMetric.sensorId === SENSOR_BATTERY">
                <article>
                  <div class="battery-insight-icon"><i class="feather icon-battery"></i></div>
                  <div><span>Batería restante</span><strong>{{ formatBatteryPercentage() }}</strong>
                    <small>{{ batteryPercentage === null ? 'No hay datos para calcular el porcentaje' :
                      (batteryPercentageEstimated ? 'Calculado desde el rango de voltaje' : 'Lectura actual del sensor de batería') }}</small></div>
                </article>
                <article>
                  <div class="battery-insight-icon autonomy"><i class="feather icon-clock"></i></div>
                  <div><span>Autonomía estimada</span><strong>{{ formatBatteryAutonomy() }}</strong>
                    <small>{{ batteryAutonomyDetail }}</small></div>
                </article>
              </div>
              <div class="stats-grid history-stats">
                <article><span>Promedio</span><strong>{{ formatValue(activeStats.average, activeMetric.unit) }}</strong>
                  <small>{{ historyRangeLabel }}</small></article>
                <article><span>Mínimo</span><strong>{{ formatValue(activeStats.minimum, activeMetric.unit) }}</strong>
                  <small>Menor lectura</small></article>
                <article><span>Máximo</span><strong>{{ formatValue(activeStats.maximum, activeMetric.unit) }}</strong>
                  <small>Pico del período</small></article>
                <article><span>Último dato</span><strong>{{ formatValue(activeStats.current, activeMetric.unit) }}</strong>
                  <small *ngIf="activeStats.lastUpdate">{{ activeStats.lastUpdate | date:'dd/MM/yyyy HH:mm' }}</small></article>
                <article><span>Mensajes recibidos</span><strong>{{ activeStats.sampleCount }}</strong>
                  <small>{{ historyRangeLabel }}</small></article>
              </div>
            </div>

            <aside class="current-location-card">
              <div class="content-card-heading">
                <h2>Ubicación actual</h2>
                <button type="button" (click)="selectTab('location')">Abrir en mapa <i class="feather icon-external-link"></i></button>
              </div>
              <ng-container *ngIf="hasCoordinates; else noCompactLocationData">
                <div class="compact-location-map">
                  <google-map width="100%" height="100%" [center]="locationMapCenter" [zoom]="locationMapZoom"
                              [options]="locationMapOptions">
                    <map-marker [position]="locationMapCenter" [options]="locationMarkerOptions"></map-marker>
                  </google-map>
                </div>
                <div class="compact-location-summary">
                  <div><span>Dirección</span><strong>{{ assetAddress }}</strong></div>
                  <div><span>Coordenadas</span><strong>{{ coordinates }}</strong><small>{{ positionSourceLabel }}</small></div>
                  <div><span>Altitud</span><strong>{{ formatValue(altitudeCurrent, 'm') }}</strong></div>
                </div>
                <div class="compact-location-update">
                  Última actualización: {{ lastUpdate ? (lastUpdate | date:'dd/MM/yyyy HH:mm') : 'Sin datos' }}
                </div>
              </ng-container>
              <ng-template #noCompactLocationData>
                <div class="empty-state compact-map-empty"><div class="empty-icon">⌖</div><h3>Sin ubicación disponible</h3>
                  <p>El activo no tiene coordenadas válidas.</p></div>
              </ng-template>
            </aside>
          </section>

          <section class="tab-content configuration-tab" *ngIf="activeTab === 'configuration'">
            <div class="alarm-config-heading">
              <div><h2>Configuración de alarmas</h2><p>{{ alarmConfigurationSubtitle }}</p></div>
              <span class="config-count" *ngIf="alarmConfiguration">{{ alarmConfiguration.configured_count }} configuradas</span>
            </div>

            <div class="empty-state" *ngIf="alarmConfigurationLoading && !alarmConfiguration">
              <div class="loader" aria-hidden="true"></div><h3>Cargando configuración</h3>
              <p>Consultando las alarmas definidas para el equipo.</p>
            </div>
            <div class="empty-state" *ngIf="!alarmConfigurationLoading && alarmConfigurationError">
              <div class="empty-icon">!</div><h3>Sin configuración disponible</h3>
              <p>{{ alarmConfigurationError }}</p>
              <button type="button" class="photo-dialog-button" *ngIf="activeDevice?.id" (click)="loadAlarmConfiguration(true)">Reintentar</button>
            </div>

            <ng-container *ngIf="alarmConfiguration">
              <div class="alarm-config-grid">
                <article class="alarm-config-card" *ngFor="let card of alarmConfigurationCards" [class.is-missing]="card.status === 'missing'">
                  <header>
                    <span class="config-icon"><i class="feather" [ngClass]="'icon-' + card.icon" aria-hidden="true"></i></span>
                    <div><h3>{{ card.title }}</h3><small>{{ card.subtitle }}</small></div>
                  </header>
                  <strong>{{ card.value }}</strong>
                  <span class="config-status" [ngClass]="'status-' + card.status">
                    <i class="feather" aria-hidden="true"
                       [ngClass]="card.status === 'ok' ? 'icon-check-circle' : card.status === 'warning' ? 'icon-alert-triangle' : 'icon-slash'"></i>
                    {{ card.statusLabel }}
                  </span>
                </article>
              </div>

              <article class="alarm-config-card position-config-card" *ngIf="positionAlarmCard as position">
                <header>
                  <span class="config-icon"><i class="feather" [ngClass]="'icon-' + position.icon" aria-hidden="true"></i></span>
                  <div><h3>{{ position.title }}</h3><small>{{ position.subtitle }}</small></div>
                  <span class="zone-badge" [ngClass]="'zone-' + position.zone">
                    {{ position.zone === 'inside' ? 'Dentro de zona' : position.zone === 'outside' ? 'Fuera de zona' : 'Sin comparación' }}
                  </span>
                </header>
                <div class="position-metrics">
                  <div><span>Umbral</span><strong>{{ position.threshold === null ? 'Sin umbral' : formatThreshold(position.threshold, 'm') }}</strong></div>
                  <div><span>Distancia registrada</span><strong>{{ position.distance === null ? '--' : formatThreshold(position.distance, 'm') }}</strong></div>
                  <div><span>Margen restante</span><strong>{{ position.margin === null ? '--' : formatThreshold(position.margin, 'm') }}</strong></div>
                </div>
                <div class="zone-progress" [ngClass]="'zone-' + position.zone"><i [style.width.%]="position.progress"></i></div>
                <p>Última distancia calculada con los datos GPS proporcionados. No representa una medición en vivo.</p>
              </article>

              <article class="alarm-config-card scope-config-card" *ngFor="let card of unassignedAlarmCards">
                <header>
                  <i class="feather scope-icon" [ngClass]="'icon-' + card.icon" aria-hidden="true"></i>
                  <h3>{{ card.title }}</h3>
                  <span class="scope-badge">Alcance por verificar</span>
                </header>
                <div class="scope-threshold"><span>Umbral configurado</span><strong>{{ card.threshold }}</strong></div>
                <p>{{ card.detail }}</p>
              </article>
            </ng-container>
          </section>

          <section class="tab-content information-tab" *ngIf="activeTab === 'information'">
            <div class="info-card"><span>Jerarquía</span><strong>{{ installationName }}</strong>
              <p>Instalación → {{ location?.name || 'Ubicación' }} → {{ activeDevice?.description || assetIdentifier }}</p></div>
            <div class="info-card"><span>Ubicación actual</span><strong>{{ assetAddress }}</strong>
              <p>Coordenadas: {{ coordinates }} · {{ positionSourceLabel }}</p></div>
            <div class="info-card"><span>Activo asociado</span><strong>{{ assetModel }}</strong>
              <p>{{ assetDescription }} · Dispositivo: {{ activeDevice?.id || 'Sin información' }}</p></div>
            <div class="info-card"><span>Variables históricas</span><strong>{{ historyMetrics.length }} variables configuradas</strong>
              <!-- <p>Batería (5), altura (31), magnetómetro X/Y/Z (24–26), variación de altura (32) y magnética (33).</p> -->
              <p>Batería (5), altura (31), variación magnética (33) y RSSI en dB (38).</p></div>
            <div class="info-card photos-card"><span>Fotos de instalación</span>
              <strong>{{ photoSlides.length }} de {{ PHOTO_SLOTS.length }} fotos cargadas</strong>
              <p>Se muestran en el panel "Activo instalado"; sin fotos se usa el icono del activo.</p>
              <button type="button" class="photo-dialog-button" *ngIf="canEditPhotos" (click)="openPhotoDialog()">Subir fotos</button>
            </div>
          </section>

          <section class="tab-content location-tab" *ngIf="activeTab === 'location'">
            <ng-container *ngIf="hasCoordinates; else noLocationData">
              <div class="location-map">
                <google-map width="100%" height="360px" [center]="locationMapCenter" [zoom]="locationMapZoom"
                            [options]="locationMapOptions">
                  <map-marker [position]="locationMapCenter" [options]="locationMarkerOptions"></map-marker>
                </google-map>
              </div>
              <div class="location-summary">
                <div><span>Dirección</span><strong>{{ assetAddress }}</strong></div>
                <div><span>Coordenadas</span><strong>{{ coordinates }}</strong><small>{{ positionSourceLabel }}</small></div>
                <div><span>Instalación</span><strong>{{ installationName }}</strong></div>
              </div>
            </ng-container>
            <ng-template #noLocationData>
              <div class="empty-state"><div class="empty-icon">⌖</div><h3>Sin ubicación disponible</h3>
                <p>El activo no tiene coordenadas válidas en siac_location.</p></div>
            </ng-template>
          </section>
        </ng-container>

        <p class="data-warning" *ngIf="invalidReadingCount > 0">
          {{ invalidReadingCount }} lecturas fueron omitidas por tener fecha o valor inválido.
        </p>
      </section>
    </main>
  </div>

  <footer class="asset-footer">
    <div><span class="footer-dot"></span> Datos actuales e históricos para {{ historyRangeLabel }}</div>
    <div class="footer-actions">
      <button type="button" class="map-action" (click)="selectTab('location')">
        <i class="feather icon-map-pin"></i> Ver en mapa
      </button>
      <button type="button" class="close-action" (click)="requestClose()">Cerrar</button>
    </div>
  </footer>

  <div class="photo-dialog-backdrop" *ngIf="photoDialogOpen" (click)="closePhotoDialog()">
    <section class="photo-dialog" role="dialog" aria-modal="true" aria-labelledby="photo-dialog-title"
             (click)="$event.stopPropagation()">
      <header>
        <h2 id="photo-dialog-title">Subir fotos de instalación</h2>
        <button type="button" class="photo-dialog-close" aria-label="Cerrar" [disabled]="photoSaving"
                (click)="closePhotoDialog()">×</button>
      </header>
      <p class="photo-dialog-hint">JPG, PNG o WEBP de hasta 5 MB. Elegir un archivo reemplaza la foto de esa posición al guardar.</p>
      <div class="photo-slots">
        <div class="photo-slot" *ngFor="let slot of PHOTO_SLOTS">
          <div class="photo-slot-preview">
            <img *ngIf="photoPreview(slot) as preview; else emptyPhoto" [src]="preview" [alt]="'Vista previa foto ' + slot">
            <ng-template #emptyPhoto><span>Sin foto</span></ng-template>
            <em class="photo-slot-tag" *ngIf="photoDrafts[slot]">Nueva</em>
          </div>
          <div class="photo-slot-actions">
            <strong>Foto {{ slot }}</strong>
            <label class="photo-pick" [class.disabled]="photoSaving">
              <input type="file" accept="image/jpeg,image/png,image/webp" [disabled]="photoSaving"
                     (change)="selectPhotoDraft(slot, $event)">
              {{ hasPhoto(slot) || photoDrafts[slot] ? 'Cambiar' : 'Seleccionar' }}
            </label>
            <button type="button" class="photo-discard" *ngIf="photoDrafts[slot]" [disabled]="photoSaving"
                    (click)="discardPhotoDraft(slot)">Descartar</button>
          </div>
        </div>
      </div>
      <p class="photo-error" *ngIf="photoError">{{ photoError }}</p>
      <footer>
        <button type="button" class="photo-cancel" [disabled]="photoSaving" (click)="closePhotoDialog()">Cancelar</button>
        <button type="button" class="close-action" [disabled]="!hasPhotoDrafts || photoSaving" (click)="savePhotoDrafts()">
          {{ photoSaving ? 'Subiendo…' : 'Guardar fotos' }}
        </button>
      </footer>
    </section>
  </div>
</div>
